import { models } from "types/api/viewModels.ts";
import { OrderSummaryCardShippingDetailsContainer } from "components/OrderSummaryCard/OrderSummaryCard.styles.ts";
import { SingleCardTrackingText, SingleCardTruckText } from "constants/text.ts";

export const OrderSummaryCardShippingDetails = ({
	shippingDetails
}: {
	shippingDetails: models["OrderViewModel"]["shippingDetails"];
}) => {
	const { truckNumber, trackingNumber } = shippingDetails ?? {};

	if (truckNumber && trackingNumber) {
		return (
			<OrderSummaryCardShippingDetailsContainer>
				<span className="subtitle1">{SingleCardTrackingText}: </span>
				<span data-testid="single-card-tracking-number">{trackingNumber}</span>
			</OrderSummaryCardShippingDetailsContainer>
		);
	}

	if (truckNumber) {
		return (
			<OrderSummaryCardShippingDetailsContainer>
				<span>{SingleCardTruckText}: </span>
				<span data-testid="single-card-truck-number">{truckNumber}</span>
			</OrderSummaryCardShippingDetailsContainer>
		);
	}

	if (trackingNumber) {
		return (
			<OrderSummaryCardShippingDetailsContainer>
				<span className="subtitle1">{SingleCardTrackingText}: </span>
				<span data-testid="single-card-tracking-number">{trackingNumber}</span>
			</OrderSummaryCardShippingDetailsContainer>
		);
	}

	return null;
};
